// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3353":"85310d1e","4191":"8c25e64d","4714":"ee19a799","4744":"85310d1e","9237":"9bdd9f98","9732":"85310d1e"}[chunkId] + ".chunk.css";
};